
const agent = {
  createNew: {
    newReservation: 'הזמנה חדשה',
    quickReservation: 'הזמנה מהירה',
  },

  searchBox: {
    searchBtn: 'חיפוש',
  },

  table: {
    myLastBookingsTable: {
      title: 'ההזמנות האחרונות שלי',
      headers: {
        id: 'מזהה',
        date: 'תאריך',
        status: 'סטטוס',
        passenger: 'נוסע',
      },
    },
    myRecentViewsTable: {
      title: 'הצפיות האחרונות שלי',
      headers: {
        id: 'מזהה',
        date: 'תאריך',
        status: 'סטטוס',
        passenger: 'נוסע',
      },
    },
  },

  statistics: {
    lastWeek: {
      title: 'השבוע שעבר',
    },
    last24Hours: {
      title: '24 השעות האחרונות',
    },
    myLastWeek: {
      title: 'השבוע שעבר שלי',
    },
    myLast24Hours: {
      title: '24 השעות האחרונות שלי',
    },
  },

  weatherInfo: {
    title: 'מזג אוויר',
    noNewMessages: 'אין הודעות חדשות',
    loadingWeather: 'טוען מזג אוויר...',
  },

  radioButton: {
    showTen: '10',
    showFive: '5',
  },
};

export default agent;
